import { NidPageIdentifier } from '../../types'

const useNeuroId = () => {
  /**
   * Set page identifier for NeuroID
   * */
  const setPageIdentifier = (pageIdentifier: string) => {
    // @ts-expect-error nid is loaded from NeuroID script
    window.nid('start', pageIdentifier)
  }

  const initialize = (
    userId: string,
    variables: Record<string, string> = {},
    pageIdentifier?: NidPageIdentifier
  ) => {
    // @ts-expect-error nid is loaded from NeuroID script
    window.nid('identify', userId)
    // @ts-expect-error nid is loaded from NeuroID script
    window.nid('start', pageIdentifier || 'start')
    Object.entries(variables).forEach(([name, value]) => {
      // @ts-expect-error nid is loaded from NeuroID script
      window.nid('setVariable', name, value)
    })
  }

  /**
   * Set NeuroID Checkpoint.
   * */
  const setCheckpoint = (checkpoint: string) => {
    // @ts-expect-error nid is loaded from NeuroID script
    window.nid('setCheckpoint', checkpoint)
  }

  const submit = (pageIdentifier?: NidPageIdentifier) => {
    // @ts-expect-error nid is loaded from NeuroID script
    window.nid('applicationSubmit', pageIdentifier || 'application_submit')
    // @ts-expect-error nid is loaded from NeuroID script
    window.nid('sendData')
  }

  return { initialize, submit, setCheckpoint, setPageIdentifier }
}

export default useNeuroId
